import { Alert as BaseAlert } from 'react-native';
import { IS_WEB } from '../../lib/appConstants';
import { t } from '../../utils/appUtils';

const Alert = IS_WEB
  ? {
      alert: (
        title: string,
        description: string,
        actions: { text: string; style?: string; onPress?: Function }[],
      ) => {
        if (window.confirm(`${title}\n${description}`)) {
          actions[1].onPress!();
        }
      },
    }
  : {
      alert: (...args: any[]) => {
        (BaseAlert.alert as any)(...args);
      },
    };

export const confirm = (title: string, onOk: Function) => {
  Alert.alert(title, t('areYouSure'), [
    { text: t('cancel'), style: 'cancel' },
    {
      text: t('yes'),
      onPress: onOk,
    },
  ]);
};

export default Alert;
